export enum TransferType {
  Agent = 'agent',
  Group = 'group',
}

export enum TransferTitle {
  Agent = 'Agent',
  Group = 'Group',
}
